import React from "react";
import {
    PieChart,
    Pie,
    Cell,
    ResponsiveContainer,
    Tooltip,
} from "recharts";

const defaultData = [
    { name: "Completado", value: 35 },
    { name: "Pendiente", value: 65 },
];

const defaultColors = ["url(#greenGradient)", "url(#blackGradient)"];
const RADIAN = Math.PI / 180;

const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
}) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
        <text
            x={x}
            y={y}
            fill="white"
            fontSize={12}
            textAnchor="middle"
            dominantBaseline="central"
        >
            {`${((percent ?? 0) * 100).toFixed(0)}%`}
        </text>
    );
};

const DonutChart = ({
    height = 200,
    width = "100%",
    data = defaultData,
    showTooltip = false,
    showSliceLabels = false,
    colors = defaultColors,
}) => {
    const outerRadius = Math.floor(height / 2) - 10;
    const innerRadius = Math.floor(outerRadius * 0.4);

    return (
        <ResponsiveContainer height={height}>
            <PieChart>
                <defs>
                    <linearGradient id="greenGradient" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#6EDC90" />
                        <stop offset="100%" stopColor="#49C97D" />
                    </linearGradient>
                    <linearGradient id="blackGradient" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#000000" />
                        <stop offset="100%" stopColor="#777777" />
                    </linearGradient>
                </defs>

                <Pie
                    data={data}
                    cx="50%"
                    cy="50%"
                    innerRadius={innerRadius}
                    outerRadius={outerRadius}
                    paddingAngle={0}
                    dataKey="value"
                    labelLine={false}
                    label={showSliceLabels ? renderCustomizedLabel : undefined}
                >
                    {data.map((entry, index) => (
                        <Cell
                            key={`cell-${index}`}
                            fill={colors[index % colors.length]}
                        />
                    ))}
                </Pie>

                {showTooltip && <Tooltip />}
            </PieChart>
        </ResponsiveContainer>
    );
};

export default DonutChart;
